const bubbles = {
  init(el) {
    const setLocation = (c) => {
      const bubbleHeight = ~~(c.offsetHeight);
      // 8 = arrow height
      const totalMargin = bubbleHeight + 8;
      c.style.marginBottom = `-${totalMargin}px`;
    };
    setLocation(el);
    el.addEventListener('click', () => {
      setLocation(el);
    });
  },
};

export { bubbles };



// WEBPACK FOOTER //
// ./src/directives/bubbles.js